// CO2 — chest-reveal roulette feel. Pure helper: the per-tick delays for a slot-machine spin that starts
// fast and eases out to a stop, so the reveal builds tension instead of cycling at a flat rate. UI-only.

/** Ease-out spin schedule: `ticks` delays (ms) growing from `fast` to `slow` as the reel slows to a stop. */
export function chestSpinDelays(ticks: number, fast = 45, slow = 200): number[] {
  const n = Math.max(1, Math.floor(ticks))
  const out: number[] = []
  for (let i = 0; i < n; i++) {
    const p = n <= 1 ? 1 : i / (n - 1)
    const eased = p * p // quadratic ease-out → noticeable slowdown near the end
    out.push(Math.round(fast + (slow - fast) * eased))
  }
  return out
}
